import { IconRocket02 } from 'components/Icons';
import router from 'next/router';
import { generateDeployNewModelUrl } from 'modules/Compute/utils';
import { computeActionStyles } from 'modules/Compute/styles';
import { baseTheme } from 'styles/utils';

export const DeployModelButton = ({ clusterId, nodePoolId, onClick }: { clusterId: string; nodePoolId: string; onClick?: () => void }) => {
  const handleClick = () => {
    onClick?.();
    router.push(generateDeployNewModelUrl({ clusterId, nodePoolId }));
  };

  return (
    <div
      tabIndex={0}
      role="button"
      className={computeActionStyles.actionListButton}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <IconRocket02 color={baseTheme.light.colors.gray700} size={18} />
      Deploy a Model
    </div>
  );
};
